import React, { useState } from 'react';
import ComponentContainer from '../../components/component-container/ComponentContainer';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import SignatureRequirements from './SignatureRequirements';
import imgSignatureLoader from '../../images/img_signature_loader.svg';
import imgDocumentToSign from '../../images/img_documents_to_sign.svg';
import { CheckCheck, Search } from 'lucide-react';

import './Requirements.css';
import ConsultRequirements from './ConsultRequirements';
import ValidateDocumentRequirements from './ValidateDocumentRequirements';

const Requirements = () => {
	const [open, setOpen] = React.useState(false);
	const [selectedModal, setSelectedModal] = useState<string | null>();

	const handleClose = () => {
		setOpen(false);
	};

	const selectModal = (requirementOption: string) => {
		setSelectedModal(requirementOption);
		setOpen(true);
	};

	return (
		<ComponentContainer>
			<h1>Requisitos</h1>
			<div className="cyber-spacer medium"></div>

			<p>
				Los procesos de firma electrónica son rápidos, sencillos y
				seguros para el usuario.
			</p>

			<div className="cyber-grid three-columns">
				<div
					className="cyber-card bordered flex direction-column justify-between align-start"
					onClick={() => selectModal('signature-requirements')}
				>
					<h5>Productos de firma electrónica</h5>
					<div
						style={{
							position: 'relative',
							top: '15px',
							right: '-30px',
						}}
					>
						<div>
							<img
								style={{
									position: 'relative',
									width: '200px',
									top: '10px',
									padding: '0 0 0 0',
								}}
								src={imgDocumentToSign}
								alt=""
							/>
						</div>
						<div>
							<img
								style={{
									position: 'relative',
									width: '75px',
									top: '-88px',
									right: '-80px',
									padding: '0 0 0 0',
								}}
								src={imgSignatureLoader}
								alt=""
							/>
						</div>
					</div>
				</div>

				<div
					className="cyber-card bordered flex direction-column justify-between align-start"
					whileHover={{
						scale: 1.1,
					}}
					onClick={() =>
						selectModal('validate-document-requirements')
					}
				>
					<h5>Validación de documentos</h5>
					<div className="cyber-spacer medium"></div>
					<div style={{ width: '250px', height: '200px' }}>
						<CheckCheck
							style={{
								position: 'relative',
								right: '-130px',
								top: '40px',
								transform: 'scale(8)',
							}}
						/>
					</div>
				</div>

				<div
					className="cyber-card bordered flex direction-column justify-between align-start"
					whileHover={{
						scale: 1.1,
					}}
					onClick={() => selectModal('consult-requirements')}
				>
					<h5>Consultar Certificado</h5>
					<div className="cyber-spacer medium"></div>
					<div style={{ width: '250px', height: '200px' }}>
						<Search
							style={{
								position: 'relative',
								right: '-130px',
								top: '45px',
								transform: 'scale(8)',
							}}
						/>
					</div>
				</div>
			</div>

			<Dialog open={open} onOpenChange={setOpen}>
				<DialogContent style={{ padding: 20 }}>
					{selectedModal !== null ? (
						selectedModal === 'consult-requirements' ? (
							<ConsultRequirements />
						) : selectedModal ===
						  'validate-document-requirements' ? (
							<ValidateDocumentRequirements />
						) : (
							<SignatureRequirements handleClose={handleClose} />
						)
					) : (
						<></>
					)}
				</DialogContent>
			</Dialog>
		</ComponentContainer>
	);
};

export default Requirements;
